import { Conversation } from "@/api/models";

/**
 * De-duplicates conversations by id, keeping the first occurrence.
 *
 * Pinned conversations are fetched separately from the paged list, so the two
 * sources can overlap (a recently-updated pinned chat appears in both). Passing
 * pinned first ensures the pinned entry is the one retained.
**/
export const dedupeConversationsById = (conversations: Conversation[]): Conversation[] => {
  const seen = new Set<string>();
  return conversations.filter((conv) => {
    const id = conv.id || "";
    if (seen.has(id)) return false;
    seen.add(id);
    return true;
  });
}
